import React from 'react';
import { renderLandingPageElement } from './LandingPage/LandingPage.js';
import { useAppSelector } from '../hooks.js';
import styles from './ModularContent.scss';
export const ModularContent = ({ content, region }) => {
    const isLoggedIn = useAppSelector((state) => state.auth.isLoggedIn);
    return (React.createElement("div", { className: styles.contentByIdContainer, "data-pw": `modularContent-${region}` }, content.map((element) => renderLandingPageElement(element, 'fi', !!isLoggedIn))));
};
